import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "order-container" }
const _hoisted_2 = { class: "top-section" }
const _hoisted_3 = { class: "restaurant-name" }
const _hoisted_4 = { class: "order-date" }
const _hoisted_5 = { class: "order-number" }
const _hoisted_6 = { class: "middle-section" }
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { class: "dish-info" }
const _hoisted_9 = { class: "dish-name" }
const _hoisted_10 = { class: "quantity-tag" }
const _hoisted_11 = { class: "bottom-section" }
const _hoisted_12 = { class: "status-text" }

import { OrderDataModel } from '@/model/kitchen';
  import { ref } from 'vue';

  // 定义Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenOrderCardCompent',
  props: {
    orderData: {
      type: Object as () => OrderDataModel,
      required: true,
    },
  },
  emits: ['serveDish', 'completeAll'],
  setup(__props, { emit: __emit }) {

  const props = __props;

  // 定义Emits
  const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.orderData.restaurantName) + "【" + _toDisplayString(__props.orderData.tableNumber) + "号桌】", 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.orderData.createDate), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.orderData.orderId), 1)
    ]),
    _createVNode(_component_van_divider, { class: "divider" }),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderData.dishes, (dish, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "dish-item"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(dish.name), 1),
              _createElementVNode("span", _hoisted_10, "数量:" + _toDisplayString(dish.quantity), 1),
              _createVNode(_component_van_button, {
                class: "serve-btn",
                round: "",
                onClick: ($event: any) => (emit('serveDish', dish.id))
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" 出餐 ", -1)
                ])),
                _: 2,
                __: [1]
              }, 1032, ["onClick"])
            ]),
            (index < __props.orderData.dishes.length - 1)
              ? (_openBlock(), _createBlock(_component_van_divider, {
                  key: 0,
                  class: "divider",
                  style: {"width":"100% !important"}
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_van_divider, { class: "divider" }),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, "状态：" + _toDisplayString(__props.orderData.status), 1),
      _createVNode(_component_van_button, {
        class: "complete-btn",
        round: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('completeAll')))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" 全部完成 ", -1)
        ])),
        _: 1,
        __: [2]
      })
    ])
  ]))
}
}

})